(ns common.schema.entities.integration.ai-options
  "Option lists for the AI service configuration entities: providers, AI task
   types, task processing statuses, and service verification outcomes.")

(def ANTHROPIC :ai.provider/anthropic)
(def OPENAI :ai.provider/openai)
(def GEMINI :ai.provider/gemini)
(def COPILOT :ai.provider/copilot)

(def provider-labels
  {ANTHROPIC "Anthropic (Claude)"
   OPENAI    "OpenAI"
   GEMINI    "Google Gemini"
   COPILOT   "Copilot (OpenAI-compatible)"})

(def provider-options
  (->> provider-labels
       (map (fn [[k l]]
              {:value k
               :label l}))))

(def TASK-TYPE-EMAIL-INGEST :ai.task-type/email-ingest)
(def TASK-TYPE-WEBENTRY-RESOLUTION :ai.task-type/webentry-resolution)
(def TASK-TYPE-DEAL-ONE-PAGER :ai.task-type/deal-one-pager)

(def task-type-labels
  {TASK-TYPE-EMAIL-INGEST        "Email ingestion"
   TASK-TYPE-WEBENTRY-RESOLUTION "Webform resolution"
   TASK-TYPE-DEAL-ONE-PAGER      "Deal one-pager"})

(def task-type-options
  (->> task-type-labels
       (map (fn [[k l]]
              {:value k
               :label l}))))

(def STATUS-PENDING :ai.status/pending)
(def STATUS-PROCESSING :ai.status/processing)
(def STATUS-COMPLETED :ai.status/completed)
(def STATUS-FAILED :ai.status/failed)
(def STATUS-TOKEN-EXHAUSTED :ai.status/token-exhausted)

(def status-labels
  {STATUS-PENDING         "Pending"
   STATUS-PROCESSING      "Processing"
   STATUS-COMPLETED       "Completed"
   STATUS-FAILED          "Failed"
   STATUS-TOKEN-EXHAUSTED "Out of tokens"})

(def status-options
  (->> status-labels
       (map (fn [[k l]]
              {:value k
               :label l}))))

;; Why an enrichment job ended in STATUS-FAILED. Stored on
;; :ai-job-enrichment/failure-reason so the client can show a specific reason
;; instead of a generic failure. STATUS-TOKEN-EXHAUSTED keeps its own status
;; and carries no failure reason.
(def FAILURE-NOT-ENABLED :ai.failure-reason/not-enabled)
(def FAILURE-NO-SERVICE :ai.failure-reason/no-service)
(def FAILURE-NO-TEMPLATE :ai.failure-reason/no-template)
(def FAILURE-ACCESS-LOST :ai.failure-reason/access-lost)
(def FAILURE-PROVIDER-ERROR :ai.failure-reason/provider-error)
(def FAILURE-UNKNOWN :ai.failure-reason/unknown)

(def failure-reason-labels
  {FAILURE-NOT-ENABLED    "AI enrichment not enabled"
   FAILURE-NO-SERVICE     "No AI service enabled"
   FAILURE-NO-TEMPLATE    "Unknown enrichment template"
   FAILURE-ACCESS-LOST    "Document no longer accessible"
   FAILURE-PROVIDER-ERROR "AI service error"
   FAILURE-UNKNOWN        "Unexpected error"})

(def failure-reason-options
  (->> failure-reason-labels
       (map (fn [[k l]]
              {:value k
               :label l}))))

;; Outcome of verifying a service against its provider. Stored on
;; :ai-service/last-verification-outcome, so these are namespaced enum values
;; rather than the bare keywords a purely in-flight classification could use.
;; The admin panel adds two unqualified markers of its own - :pending while a
;; check is in flight and :request-failed when the RPC itself failed - which are
;; view state and are deliberately not part of this list.
(def VERIFICATION-VERIFIED :ai.verification/verified)
(def VERIFICATION-RATE-LIMITED :ai.verification/rate-limited)
(def VERIFICATION-MODEL-NOT-FOUND :ai.verification/model-not-found)
(def VERIFICATION-KEY-REJECTED :ai.verification/key-rejected)
(def VERIFICATION-NO-CREDIT :ai.verification/no-credit)
(def VERIFICATION-MISSING-API-KEY :ai.verification/missing-api-key)
(def VERIFICATION-FAILED :ai.verification/failed)

;; A verification reaching the provider at all is the pass condition: a 429
;; proves the key and model resolved just as surely as a 200 does.
(def verification-passed
  #{VERIFICATION-VERIFIED
    VERIFICATION-RATE-LIMITED})

(def verification-outcome-labels
  {VERIFICATION-VERIFIED        "Verified"
   VERIFICATION-RATE-LIMITED    "Rate limited"
   VERIFICATION-MODEL-NOT-FOUND "Model not found"
   VERIFICATION-KEY-REJECTED    "API key rejected"
   VERIFICATION-NO-CREDIT       "No credit balance"
   VERIFICATION-MISSING-API-KEY "No API key"
   VERIFICATION-FAILED          "Not reachable"})

(def verification-outcome-options
  (->> verification-outcome-labels
       (map (fn [[k l]]
              {:value k
               :label l}))))
